module.exports = __webpack_public_path__ + "static/media/ActivateCode.65d7c1da.svg";